import {FC} from "react";

export const NextIcon: FC = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M1.33333 0.333984H2.66667C3.40305 0.333984 4 0.930939 4 1.66732V12.334C4 13.0704 3.40305 13.6673 2.66667 13.6673H1.33333C0.596953 13.6673 -4.17233e-07 13.0704 -4.17233e-07 12.334V1.66732C-4.17233e-07 0.930938 0.596954 0.333984 1.33333 0.333984ZM14 1.75735V12.244C14 13.3744 12.6815 13.992 11.8131 13.2683L5.52112 8.02495C4.88145 7.49189 4.88145 6.50942 5.52112 5.97636L11.8131 0.73305C12.6815 0.00935148 14 0.626898 14 1.75735Z"
                  fill="#909090"/>
        </svg>
    )
}import {FC} from "react";

export const NextIcon: FC = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M1.33333 0.333984H2.66667C3.40305 0.333984 4 0.930939 4 1.66732V12.334C4 13.0704 3.40305 13.6673 2.66667 13.6673H1.33333C0.596953 13.6673 -4.17233e-07 13.0704 -4.17233e-07 12.334V1.66732C-4.17233e-07 0.930938 0.596954 0.333984 1.33333 0.333984ZM14 1.75735V12.244C14 13.3744 12.6815 13.992 11.8131 13.2683L5.52112 8.02495C4.88145 7.49189 4.88145 6.50942 5.52112 5.97636L11.8131 0.73305C12.6815 0.00935148 14 0.626898 14 1.75735Z"
                  fill="#909090"/>
        </svg>
    )
}